<!-- Error Popup Modal -->
<div *ngIf="showPopup" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="error-modal-title" role="dialog"
  aria-modal="true">
  <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <!-- Background overlay - not clickable when not closeable -->
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" [class.cursor-not-allowed]="!isCloseable"
      (click)="isCloseable ? closePopup() : null" aria-hidden="true"></div>

    <!-- Center alignment helper -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <!-- Modal content -->
    <div
      class="inline-block align-middle bg-white rounded-lg px-6 pt-6 pb-6 text-center overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full relative">
      <!-- Error Icon -->
      <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
        <svg class="h-10 w-10 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-1.964-1.333-2.732 0L3.732 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>

      <!-- Error Title -->
      <h3 class="text-2xl font-bold text-gray-900 mb-3" id="error-modal-title">
        {{ errorTitle }}
      </h3>

      <!-- Error Message -->
      <p class="text-lg text-gray-700 mb-6">
        {{ errorMessage }}
      </p>

      <!-- Action Buttons -->
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button type="button" (click)="startNewFlow()"
          class="w-full sm:w-auto inline-flex justify-center items-center rounded-lg border border-transparent shadow-sm px-6 py-3 bg-sp-green-600 text-base font-semibold text-white hover:bg-sp-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sp-green-500 transition-colors">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
            </path>
          </svg>
          Start a New Flow
        </button>

        <!-- Only show close button if closeable -->
        <button *ngIf="isCloseable" type="button" (click)="closePopup()"
          class="w-full sm:w-auto inline-flex justify-center rounded-lg border border-gray-300 shadow-sm px-6 py-3 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sp-green-500 transition-colors">
          Close
        </button>
      </div>
    </div>
  </div>
</div>